import _toConsumableArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { POSITIONS, ALIGNS } from "../consts";

var calculatePopoverPosition = function calculatePopoverPosition(preferredPosition, preferredHoriznotalPosition) {
  var mappedPositions = Object.keys(POSITIONS).map(function (k) {
    return POSITIONS[k];
  });
  var mappedAlignPositions = Object.keys(ALIGNS).map(function (k) {
    return ALIGNS[k];
  });
  return [[preferredPosition].concat(_toConsumableArray(mappedPositions.filter(function (p) {
    return p !== preferredPosition;
  }))), [preferredHoriznotalPosition].concat(_toConsumableArray(mappedAlignPositions.filter(function (p) {
    return p !== preferredHoriznotalPosition;
  })))];
};

export default calculatePopoverPosition;